var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorRound5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_20842)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#54B0FD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_412_20842)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#54B0FD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 36,
    height: 34.5,
    rx: 6,
    fill: "url(#paint0_linear_412_20842)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34.5,
    width: 36,
    height: 1.5,
    rx: 0.75,
    fill: "url(#paint1_linear_412_20842)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_20842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7996 19.15C13.3996 18.95 12.9829 18.8167 12.5496 18.75L15.2496 6.55005H25.8496L25.2996 10.35H18.2996L17.1996 15.3C17.8996 15.0667 18.5329 14.95 19.0996 14.95C21.0663 14.95 22.5496 15.55 23.5496 16.75C24.5496 17.95 24.8829 19.75 24.5496 22.15C24.2163 24.7167 23.2329 26.65 21.5996 27.95C20.0996 29.1167 18.1496 29.7 15.7496 29.7C14.3829 29.7 13.0329 29.4167 11.6996 28.85C11.2329 28.65 10.8496 28.45 10.5496 28.25C10.2496 28.0167 10.0163 27.85 9.84961 27.75L11.4996 24.75C12.3996 25.1834 13.2829 25.5 14.1496 25.7C15.0163 25.9 15.6663 26 16.0996 26C18.1663 26 19.3996 24.7 19.7996 22.1C20.1329 19.6 19.1996 18.35 16.9996 18.35C16.3329 18.35 15.6829 18.45 15.0496 18.6501C14.4163 18.8167 13.9996 18.9834 13.7996 19.15Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_20842",
    x: 9.84961,
    y: 6.55005,
    width: 16,
    height: 24.0866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.936664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_20842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_20842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_20842",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_20842",
    x1: 0,
    y1: 35.25,
    x2: 36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517013,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_20842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_412_20842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRound5);
export default __webpack_public_path__ + "static/media/motor_round_5.9388e64077af6eee0731bc82ffa92b1e.svg";
export { ForwardRef as ReactComponent };